import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { HashRouter } from 'react-router-dom';

import configureLogging from './configureLogging';
import createStore from './createStore';

import { BundleContextProvider } from '~app/core/BundleProvider';
import AppBundleContext from '~app/core/AppBundleContext';
import App from '~app/features/app/components/App';

import '~app/styles/index.scss';

function selectLanguage() {
  if (process.env.APP_LANGUAGE === 'en') {
    return require('./resources/en/bundle').default;
  }
  /*
  else if (process.env.APP_LANGUAGE === "es") {
    return require("./resources/es/bundle").default;
  }
  */
}

configureLogging();
const appBundle = selectLanguage();

// wait for appBundle to be prepared before loading rest of app
appBundle.prepare().then(function () {
  document.getElementById('splash-screen').style.display = 'none';

  // don't block unload in DEV because it interferes with live reloading
  if (process.env.NODE_ENV !== 'development') {
    window.addEventListener('beforeunload', e => {
      // Cancel the event
      e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
      // Chrome requires returnValue to be set
      e.returnValue = '';
    });
  }

  const store = createStore();

  ReactDOM.render(
    <React.StrictMode>
      <BundleContextProvider context={AppBundleContext}>
        <ReduxProvider store={store}>
          <HashRouter basename={process.env.PUBLIC_URL}>
            <App />
          </HashRouter>
        </ReduxProvider>
      </BundleContextProvider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
});
